var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1759 16.0034L18.7593 12.4284C19.086 12.1016 19.086 11.5718 18.7593 11.2451C18.4325 10.9183 17.9027 10.9183 17.5759 11.2451L14.0009 14.8284L10.4259 11.2451L10.4259 11.2451C10.0992 10.9183 9.56936 10.9183 9.24259 11.2451C8.91582 11.5718 8.91582 12.1016 9.24259 12.4284L12.8259 16.0034L9.24259 19.5784C8.91582 19.9025 8.91366 20.4301 9.23776 20.7569C9.23936 20.7585 9.24098 20.7601 9.24259 20.7617H9.24259C9.56669 21.0885 10.0943 21.0907 10.4211 20.7666C10.4227 20.765 10.4243 20.7634 10.4259 20.7617L14.0009 17.1784L17.5759 20.7617V20.7617C17.9 21.0885 18.4277 21.0907 18.7544 20.7666C18.756 20.765 18.7577 20.7634 18.7593 20.7617C19.086 20.4376 19.0882 19.91 18.7641 19.5832C18.7625 19.5816 18.7609 19.58 18.7593 19.5784L15.1759 16.0034Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-gray.cd84c761493cb4e01a6a9affde7974c9.svg";